<script>
  import { ignore } from '../../../Common/tools';
  import { External, M } from '../../../external';
  import { onDestroy, onMount } from 'svelte';
  import Checkbox from '../../../Common/Checkbox.svelte';

  export let data = {}, onChange = ignore;

  const PAYMENT_STATUSES = [
    { id: 0, text: M.ALL_ORDERS },
    { id: 1, text: M.PAID_ORDERS },
    { id: 2, text: M.NOT_PAID_ORDERS }
  ];

  let storeProducts, settings;

  $: if (settings && settings.loaded) { //triggers on any change to the settings
    data.settings[0] = {
      key: '0',
      value: JSON.stringify({
        paymentStatus: settings.paymentStatus,
        thresholdAmount: settings.checkThresholdAmount ? settings.thresholdAmount : null,
        discountCode: settings.checkDiscountCode ? settings.discountCode : null,
        products: settings.checkIncludesProduct ? settings.products.map((p) => {
          return p.id;
        }) : []
      })
    };

    onChange();
  }

  async function getStoreProducts() {                  //fetch once, then cache
    if (!storeProducts) {
      storeProducts = await new Promise((resolve) => {
        External.Tools.getStoreProducts((products) => {
          resolve(products);
        });
      });
    }
    return storeProducts;
  }

  async function showProductPicker() {
    External.Tools.chooseMultiple({
      title: M.SELECT_STORE_PRODUCTS,
      message: '',
      allowNewItems: false,
      items: await getStoreProducts(),
      selectedItems: settings.products,
      noItemsMessage: M.NOTHING_TO_SELECT,
      width: 440,
      isModal: true,
      getItemId: function(item) {
        return item.id;
      },
      getItemText: function(item) {
        return item.name;
      },
      onSelect: function(products) {
        settings.products = products;
      }
    });
  }

  onMount(async () => {
    if (!data.settings) {
      data.settings = [];
    }

    settings = data.settings[0] ? JSON.parse(data.settings[0].value) :
      {
        paymentStatus: PAYMENT_STATUSES[0].id,
        thresholdAmount: null,
        discountCode: null,
        products: []
      };

    settings.checkThresholdAmount = settings.thresholdAmount != null;
    settings.checkIncludesProduct = settings.products.length > 0;
    settings.checkDiscountCode = settings.discountCode != null;

    if (settings.products.length) {
      settings.products = External.WebPlatform.intersect(await getStoreProducts(), settings.products, true, function(product, pid) {
        return product.id === pid;
      });
    }

    settings.loaded = true;
  });

  onDestroy(() => {
    settings = storeProducts = null;
  });

</script>

{#if settings && settings.loaded}
  <div class='col20 f-left small-rules mb-25'>
    <h4 class='col20 f-left mt-15 mb-10 t-center' style='line-height:1.4;'>{M.WHEN_CONTACT_MAKES_A_PURCHASE}</h4>
    <div class='popup-input-wrapper f-left mt-25 mb-5' id='selectContactProperty'>
      <div class='info'>
        <h5>{M.PURCHASE_CRITERIA}</h5>
      </div>
      <select class='page-select' name='grSelect' bind:value={settings.paymentStatus}>
        {#each PAYMENT_STATUSES as criteria}
          <option value={criteria.id}>
            {criteria.text}
          </option>
        {/each}
      </select>
    </div>
    <div class='popup-input-wrapper mb-5 f-left'>
      <Checkbox clz="f-left col20" bind:data={settings.checkThresholdAmount} label='{M.TRIGGER_FOR_ORDERS_OVER_AMOUNT}' />
      {#if settings.checkThresholdAmount}
        <div class='info light-gray-text'>
          {M.ENTER_AN_ORDER_VALUE}
        </div>
        <div class='symbol-input price-input'
             class:left-sign={External.Website.storeCurrencyPositionAtLeft}
             class:right-sign={!External.Website.storeCurrencyPositionAtLeft}>
          <span class='symbol-sign'>{External.Website.storeCurrencySymbol}</span>
          <input type='number' min='0.01' step='0.01' placeholder='0.00' bind:value={settings.thresholdAmount} />
        </div>
      {/if}
    </div>
    <div class='popup-input-wrapper mb-5 f-left'>
      <Checkbox clz="f-left col20" bind:data={settings.checkDiscountCode} label='{M.TRIGGER_FOR_ORDERS_WITH_DISCOUNT_CODE}' />
      {#if settings.checkDiscountCode}
        <div class='info light-gray-text'>
          {M.ENTER_THE_DISCOUNT_CODE}
        </div>
        <input type='text' placeholder='{M.DISCOUNT_CODE}' bind:value={settings.discountCode} maxlength='255' />
      {/if}
    </div>
    <div class='popup-input-wrapper mb-5 f-left' style=''>
      <Checkbox clz="f-left col20" bind:data={settings.checkIncludesProduct} label='{M.TRIGGER_FOR_ORDERS_INCL_PRODUCT}' />
      {#if settings.checkIncludesProduct}
        <div class='col20 f-left'>
          <div class='col20 f-left multiple-items-picker'>
            <ul class='groups'>
              <li class='add-group'>
                <a class='blue middle-button' on:click={showProductPicker}>{M.SELECT_PRODUCTS}</a>
              </li>
              {#if settings.products}
                {#each settings.products as product}
                  <li>{product.name}</li>
                {/each}
              {/if}
            </ul>
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}
